<script>
export default {
    name: 'IconStop'
}
</script>
<template>
    <svg
        class="base-icon icon-stop"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" d="M12 12h40v40H12z" fill-rule="evenodd" />
    </svg>
</template>
